import loader from 'little-loader';
import Promise from 'bluebird';

const CHANGE_LOG_CLASS = 'change-log';

class ChangeLogController {
    /* @ngInject */
    constructor() {
        this.accountId = CONFIGURATION.headwayAccountId;
    }

    $onInit() {
        return this.initialize().then(() => {
            this.interval = setInterval(this.update.bind(this), this.updateInterval);
        }).catch(() => null);
    }

    $onDestory() {
        if (this.interval) {
            clearInterval(this.interval);
        }

        return this.getInstance().then((instance) => {
            instance.destroy();
        }).catch(() => null);
    }

    initialize() {
        return this.getInstance().then((instance) => {
            instance.init({
                selector: `.${CHANGE_LOG_CLASS}`,
                account: this.accountId
            });

            return instance;
        });
    }

    update() {
        return this.getInstance().then((instance) => {
            if (!instance.visible) {
                return this.initialize();
            }

            return instance;
        }).catch(() => null);
    }

    getInstance() {
        if (!this.instance) {
            this.instance = new Promise((resolve, reject) => {
                if (this.accountId) {
                    return loader('https://cdn.headwayapp.co/widget.js', (error) => {
                        if (error) {
                            return reject(error);
                        }

                        return resolve(window.Headway);
                    });
                }

                return reject(new Error(`The change log is disabled.`));
            });
        }

        return this.instance;
    }
}

export default {
    selector: 'dbAChangeLog',
    template: `<div class="${CHANGE_LOG_CLASS}"></div>`,
    controller: ChangeLogController,
    bindings: {
        updateInterval: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/change-log/change-log.cmpt.js